import { Component, OnInit } from '@angular/core';
import { PrimeNG } from 'primeng/config';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent implements OnInit {

    constructor(private primeng: PrimeNG) { }

   

    ngOnInit(): void {
        this.loadGoogleMaps();

        // Verifica se o ambiente mudou e limpa o localStorage se necessário
        this.checkEnvironmentChange();

        this.primeng.setConfig({ ripple: true });

        this.primeng.setTranslation({
            apply: 'Aplicar',
            clear: 'Limpar',
            accept: 'Sim',
            reject: 'Não',
            firstDayOfWeek: 0,
            dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
            dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
            dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
            monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho',
              'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
            monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
            today: 'Hoje'
        });

        this.getDeviceType()
        
    }

    private loadGoogleMaps(): void {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&loading=async`;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
    }

    checkEnvironmentChange(): void {
        // Inclui a origem da aplicação para diferenciar entre localhost, homolog, prod, etc
        const appOrigin = window.location.origin;
        const apiEnvironment = environment.urlBase + (environment.ambiente || '');
        const currentEnvironment = `${appOrigin}|${apiEnvironment}`;
        const savedEnvironment = localStorage.getItem('app_environment');

        // Se o ambiente mudou (origem ou API), limpa o localStorage (exceto device)
        if (savedEnvironment && savedEnvironment !== currentEnvironment) {
            const device = localStorage.getItem('device');
            localStorage.clear();
            if (device) {
                localStorage.setItem('device', device);
            }
        }

        // Salva o ambiente atual (origem + API)
        localStorage.setItem('app_environment', currentEnvironment);
    }

    getDeviceType = () => {
        const ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
            return "tablet";
        }
        if (
            /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
                ua
            )
        ) {
            
            localStorage.setItem('device', "mobile");
            return "mobile";
        }
       
        localStorage.setItem('device', "desktop");
        return "desktop";
    };

}
